import { FiltrerAction, PendingEmailLog } from './types'
import { RESET_FILTERS, UPDATE_APP_ID, UPDATE_QUERY, UPDATE_TEMPLATE_NAME } from './actions'

const initialState: PendingEmailLog = {
  Query: '',
  TemplateName: '',
  AppId: 1
}

export function pendingEmailReducer(state: PendingEmailLog = initialState, FiltrerAction: FiltrerAction): PendingEmailLog {
  switch (FiltrerAction.type) {
    case UPDATE_QUERY:
      return { ...state, Query: FiltrerAction.payload }
    case UPDATE_TEMPLATE_NAME:
      return { ...state, TemplateName: FiltrerAction.payload }
    case UPDATE_APP_ID:
      return { ...state, AppId: FiltrerAction.payload }
    case RESET_FILTERS:
      return {
        ...state,
        Query: '',
        TemplateName: ''
      }
    default:
      return state
  }
}
